'use client'

import React from 'react'
import { getProductUrl } from '@dustin-web/microsite-components/src/utils/urls'
import { TicketLink } from '../ticket-link'
import { Maybe, ProductTypeProps } from '../cards'
import classNames from 'classnames'
import { handeOnClickProduct } from '../cards/utils'
import { Card } from '../cards/product-card-gallery-composable'
import { DigitalDataOrigin } from '../utils/digital-data-types'

type Props = {
  product?: Maybe<ProductTypeProps>
  ticket: string
  imagePriority?: boolean
  isLastItem: boolean
  digitalDataIndex: number
  digitalDataOrigin: DigitalDataOrigin
}

const RecentlyViewedProduct = ({
  product,
  ticket,
  imagePriority = false,
  isLastItem,
  digitalDataIndex,
  digitalDataOrigin,
}: Props) => {
  if (!product) {
    return null
  }
  const summaryMaxCharacters = 150

  const productUrl = getProductUrl(product.id, product.nameSlug)

  return (
    <Card.Container
      digitalIndex={digitalDataIndex}
      product={product}
      digitalDataOrigin={digitalDataOrigin}
      customClassName={classNames('u-px-12 u-py-8 u-border-light', {
        'u-bb': !isLastItem,
      })}>
      <div className="row sm-gutters">
        <div className="col-2 col-md-3">
          <Card.Picture
            ticket={ticket}
            digitalDataIndex={digitalDataIndex}
            digitalDataOrigin={digitalDataOrigin}
            product={product}
            imageWidth={50}
            imageHeight={50}
            imagePriority={imagePriority}
          />
        </div>
        <div className="col-10 col-md-9 u-fs-12 row sm-gutters align-content-center ">
          <div className="u-color-mute col-12">{product.manufacturerName}</div>

          <TicketLink
            url={productUrl}
            ticket={ticket}
            onClickCallBack={() => handeOnClickProduct('recentlyViewed', product, digitalDataIndex)}
            className="u-fw-bold u-fs-12 u-decoration-none col-12">
            {product.displayName}
            {`${product.displaySpecifications.substring(0, summaryMaxCharacters)}${
              product.displaySpecifications.length > summaryMaxCharacters ? '...' : ''
            }`}
          </TicketLink>
        </div>
      </div>
    </Card.Container>
  )
}

export default RecentlyViewedProduct
